module.exports = __webpack_public_path__ + "img/item-5-2.e4a738d3.png";